import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentSavedAsDraftLogEvent = unifiedAgentEvent<{
  build_session_id: string | null
  prompt_count: number
  agent_id: number
}>('Unified_Agent_Saved_As_Draft')
